import { render, staticRenderFns } from "./WebPhoneIcon.vue?vue&type=template&id=4c8e59ff&scoped=true"
import script from "./WebPhoneIcon.vue?vue&type=script&lang=js"
export * from "./WebPhoneIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8e59ff",
  null
  
)

export default component.exports